import Header from "@/components/feature/Header";
import Footer from "@/components/feature/Footer";
import PiecesSection from "@/components/feature/PiecesSection";
import ServicesSection from "@/components/feature/ServicesSection";
import { defaultPieces, defaultServices } from "@/mocks/servicesSections";
import VideoDiagnostic from "@/components/feature/VideoDiagnostic";
import { useSEO } from "@/hooks/useSEO";
import { seoData } from "@/data/seoData";
import ContactForm from "@/pages/home/components/ContactForm";
import GoogleReviews from "@/components/feature/GoogleReviews";
import Hero from "./components/Hero";
import NotreEntreprise from "./components/NotreEntreprise";
import NosEngagements from "./components/NosEngagements";
import AllBrands from "./components/AllBrands";
import Gallery from "./components/Gallery";
import ContactBlock from "./components/ContactBlock";
import FloatingButton from "./components/FloatingButton";

export default function QuiSommesNousPage() {
  useSEO(seoData.quiSommesNous);
  return (
    <>
      <Header />
      <main>
        <Hero />
        <VideoDiagnostic />
        <PiecesSection {...defaultPieces} />
        <ServicesSection {...defaultServices} />
        <NotreEntreprise />
        <NosEngagements />
        <AllBrands />
        <Gallery />
        <ContactBlock />
        <GoogleReviews />
        <ContactForm />
      </main>
      <Footer />
      <FloatingButton />
    </>
  );
}